export default __webpack_public_path__ + "static/9bd77f0a-3ed7-4be8-adeb-633f511ba66a-869e2a89ade3e0f684541c1c25d81334.woff2";